import {
  GET_FORM_WITH_MAIN_SECTIONS,
  GET_ENTITY_TYPE_ASSIGNED_QUESTIONS,
  get_headers,
  get_token,
} from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import axios from "axios";


export default {
    name: "ComplianceChecklist",
    mixins: [alert_mixin],
    data: () => ({
        token: get_token(),
        headers: get_headers(),
        form: null,
        form_id: null,
        loading: true,
        show_assign_modal: false,
        selected_question: null,
        selected_section_name: "",
        new_target_question: {
            question_text: "",
            question_type: "text",
            is_mandatory: false,
        },
        // Track which sections are open
        open_sections: [],
        question_list: [],
        selected_question_text: "",
        question_search: "",
        is_loading_questions: false,
        entity_type_id: null,
    }),
    created() {
        this.form_id = this.$route.query.form_id;
        this.entity_type_id = sessionStorage.getItem("entity_type_id");
        this.get_assigned_questions();
    },
    computed: {
        filtered_questions() {
            const questions = Array.isArray(this.question_list) ? this.question_list : [];
            const search_text = (this.question_search || "").trim().toLowerCase();

            if (!search_text) {
            return questions;
            }

            return questions.filter((item) => {
                
            const question_text =
                item?.question?.question_text ||
                item?.question_text ||
                "";
            return question_text.toLowerCase().includes(search_text);
            });
        },
    },
    methods: {
        get_form_sections_with_sections() {
            this.loading = true;
            axios
                .get(GET_FORM_WITH_MAIN_SECTIONS, {
                    headers: this.headers,
                    params: {
                        form_id: this.form_id,
                    },
                })
                .then((response) => {
                    const resp = response.data;
                    this.form = this.normalize_form_response(resp);
                    this.ensure_question_defaults(this.form);

                    // Open first section by default
                    if (this.form.length > 0 && this.form[0].sub_sections?.length > 0) {
                        this.open_sections = [this.form[0].sub_sections[0].section_id];
                    }
                })
                .catch((error) => {
                    this.show_error("Error fetching form sections: " + error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        normalize_form_response(resp) {
            if (Array.isArray(resp)) return resp;
            if (Array.isArray(resp?.data)) return resp.data;
            if (Array.isArray(resp?.main_sections)) return resp.main_sections;
            return [];
        },

        ensure_question_defaults(form) {
            if (!Array.isArray(form)) return;
            form.forEach((main_section) => {
                const sub_sections = Array.isArray(main_section.sub_sections) ? main_section.sub_sections : [];
                sub_sections.forEach((sub_section) => {
                    const questions = Array.isArray(sub_section.questions) ? sub_section.questions : [];
                    questions.forEach((question) => {
                        if (!question.target_questions) {
                            if (typeof this.$set === "function") {
                                this.$set(question, "target_questions", []);
                            } else {
                                question.target_questions = [];
                            }
                        }

                        if (!Array.isArray(question.dependent_questions)) {
                            question.dependent_questions = [];
                        }
                        if (typeof question.is_assigned === "undefined") {
                            question.is_assigned = false;
                        }
                        if (typeof question.is_loading === "undefined") {
                            question.is_loading = false;
                        }
                    });
                });
            });
        },
        get_assigned_questions() {
            this.is_loading_questions = true;

            axios.get(GET_ENTITY_TYPE_ASSIGNED_QUESTIONS, {
                headers: this.headers,
                params: { entity_type_id: this.entity_type_id },
            })
            .then((response) => {
                const raw = response.data.data || [];
                this.question_list = raw.map(item => ({
                ...item,
                dependent_questions: Array.isArray(item.dependent_questions) ? item.dependent_questions : [],
                target_questions: Array.isArray(item.target_questions) ? item.target_questions : [],
                is_assigned: typeof item.is_assigned === "undefined" ? false : item.is_assigned,
                is_loading: typeof item.is_loading === "undefined" ? false : item.is_loading,
                }));
            })
            .catch((error) => {
                this.show_error("Error fetching assigned questions: " + error.message);
            })
            .finally(() => {
                this.is_loading_questions = false;
            });
        },

        toggle_section(section_id) {
            const index = this.open_sections.indexOf(section_id);
            if (index > -1) {
            // Section is open, close it
            this.open_sections.splice(index, 1);
            } else {
            // Section is closed, open it
            this.open_sections.push(section_id);
            }
        },
        is_section_open(section_id) {
            return this.open_sections.includes(section_id);
        },
        format_question_type(type) {
            switch (type) {
                case "short_text":
                case "long_text":
                return "Text";
                case "single_select":
                return "Single Select";
                case "multi_select":
                return "Multi Select";
                case "number":
                return "Number";
                case "date":
                return "Date";
                case "file_upload":
                return "File Upload";
                default:
                return type;
            }
        },

        set_selected_question(section_question, section_name) {
            this.selected_question = section_question;
            this.selected_section_name = section_name;

            this.selected_question_text =
                section_question?.question_text ||
                section_question?.question?.question_text ||
                "Selected question";

            this.question_search = "";
        },

        close_assign_modal() {
            this.show_assign_modal = false;
            this.selected_question = null;
            this.selected_section_name = "";
        },
    },
    mounted() {
        this.get_form_sections_with_sections();
    },
};